import { AbstractControl, ValidationErrors } from '@angular/forms';
import { parse } from 'libphonenumber-js';

export function phoneNumberValidator(
  control: AbstractControl
): ValidationErrors | null {
  const phone = control.value;
  if (!phone) return null;
  return parse(phone, 'US').country ? null : { phoneNumber: true };
}
